import React from "react";

export const MatchBar = ({ score = 0, size = "md" }) => {
    const filled = Math.round((score / 100) * 10);
    return (
        <div className="flex items-center gap-3" data-testid="match-score-indicator">
            <div className={size === "lg" ? "w-40 match-bar" : "w-28 match-bar"}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <div
                        key={`cell-${i}`}
                        className={`match-cell ${i < filled ? "on" : ""}`}
                        style={size === "lg" ? { height: 14 } : undefined}
                    />
                ))}
            </div>
            <div className="font-mono-plex text-sm tabular-nums text-slate-950">
                {score}
                <span className="text-slate-400">/100</span>
            </div>
        </div>
    );
};

export default MatchBar;
